import { useState } from "react"
import { Controller } from "react-hook-form"
import { Button, Field, Input, InputGroup } from "@chakra-ui/react"

export default function Password({ control, rules, name, value, label, help }) {
    const [showPassword, setShowPassword] = useState(false)
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={value || ""}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Field.Root invalid={!!error}>
                        <Field.Label htmlFor={name}>{label}</Field.Label>
                        <InputGroup
                            endElement={
                                <Button
                                    h="1.6rem"
                                    size="sm"
                                    onClick={() => setShowPassword(old => !old)}
                                    bg="#fff"
                                    color="#888"
                                    borderRadius={4}
                                    tabIndex={-1}
                                >
                                    {showPassword ? "Hide" : "Show"}
                                </Button>
                            }
                        >
                            <Input
                                {...field}
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                _placeholder={{ color: "#fff" }}
                            />
                        </InputGroup>
                        {help && <Field.HelperText>{help}</Field.HelperText>}
                        {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
                    </Field.Root>
                )
            }}
        />
    )
}
